import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';



@Injectable({
  providedIn: 'root',
})
export class VisitReasonService {
  private apiUrl = `${environment.apiUrl}/VisitReason`;  // API base url

  constructor(private http: HttpClient) {}

  // Get all VisitReasons
  getAll(): Observable<any> {
    const herader = {
      skipLoad: 'true',
    }
    return this.http.get<any>(this.apiUrl,{headers: herader});
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    const herader = {
      skipLoad: 'true',
    }
    return this.http.get<any>(`${this.apiUrl}/${countryId}`,{headers: herader});
  }

}
